import { handleActions } from 'redux-actions'

import {
  GET_CATEGORIES_START,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_CATEGORIES_FINALLY,
} from '../../../redux/actions'

const initialState = {
  data: [],
  isLoading: true,
}

export default handleActions({
  [GET_CATEGORIES_START]: state => ({
    ...state,
    isLoading: true,
    error: false
  }),
  [GET_CATEGORIES_SUCCESS]: (state, action) => ({
    ...state,
    data: action.payload,
  }),
  [GET_CATEGORIES_ERROR]: (state, action) => ({
    ...state,
    error: action.payload,
  }),
  [GET_CATEGORIES_FINALLY]: state => ({
    ...state,
    isLoading: false
  }),
}, initialState)